import React__default from 'react';
import PropTypes from 'prop-types';
import { a as IconNames } from './types-377ea632.js';
import { S as SvgAdd } from './add-fb28b503.js';
import { S as SvgFilter } from './filter-5a572cfb.js';
import { S as SvgLoading } from './loading-1f5748a2.js';
import { S as SvgMagnifyingGlass } from './magnifying-glass-00e45963.js';
import { S as SvgSearch } from './search-1650afd3.js';
import { S as SvgDown } from './down-a4c956cc.js';
import { S as SvgCloseThin } from './close-thin-0bb1e64b.js';
import { S as SvgTickFilled } from './tick-filled-01f90247.js';

const {
  ADD,
  CLEAR,
  FILTER,
  LOADING,
  MAGNIFYING_GLASS,
  NONE,
  SEARCH,
  SELECT,
  VALIDATE_SUCCESS
} = IconNames;
const IconRouter = ({
  iconName
}) => {
  const iconMap = {
    [ADD]: /*#__PURE__*/React__default.createElement(SvgAdd, null),
    [CLEAR]: /*#__PURE__*/React__default.createElement(SvgCloseThin, null),
    [FILTER]: /*#__PURE__*/React__default.createElement(SvgFilter, null),
    [LOADING]: /*#__PURE__*/React__default.createElement(SvgLoading, null),
    [MAGNIFYING_GLASS]: /*#__PURE__*/React__default.createElement(SvgMagnifyingGlass, null),
    [NONE]: null,
    [SEARCH]: /*#__PURE__*/React__default.createElement(SvgSearch, null),
    [SELECT]: /*#__PURE__*/React__default.createElement(SvgDown, null),
    [VALIDATE_SUCCESS]: /*#__PURE__*/React__default.createElement(SvgTickFilled, null)
  };
  return iconMap[iconName] || null;
};
IconRouter.defaultValues = {
  iconName: IconNames.NONE
};
IconRouter.propTypes = {
  iconName: PropTypes.oneOf(Object.values(IconNames))
};

export { IconRouter as default };
